import React from 'react';

import type {
  ByfunnFront,
  FrapiBundleItem,
  FrapiTeaserItem,
  Widget,
} from '../../../types/frapi-types.js';

import GuidesWidget from './GuidesWidget.js';
import RestaurantsWidget from './RestaurantsWidget.js';

const hasTeaserItems = (items: (FrapiBundleItem | FrapiTeaserItem)[]) =>
  items.some((item) => item.type === 'teaser' && item.src === 'b2b');

export function renderWidget(
  w: Widget,
  isMobile: boolean,
  index: number,
  response: ByfunnFront,
): React.ReactNode {
  if (
    w.component === 'guides' &&
    response.widgetGuides &&
    hasTeaserItems(response.widgetGuides.items)
  ) {
    return (
      <GuidesWidget
        feed={response.feed}
        data={response.widgetGuides}
        index={index}
        isMobile={isMobile}
      />
    );
  }
  if (
    w.component === 'restaurants' &&
    response.restaurantGuides &&
    'items' in response.restaurantGuides
  ) {
    return (
      <RestaurantsWidget data={response.restaurantGuides} isMobile={isMobile} />
    );
  }

  return null;
}
